import React from 'react'
import { apartments } from '../../../utils/redux/config/apartments'
import PageLayout from '../../../components/layouts/PageLayout'
import Table from '../../../components/Table'
import { getStatusColor, getRoomAndType, getTypeFilterOptions, getStatusFilterOptions } from '../../../utils/apartments'
import { textFilter, selectFilter } from 'react-bootstrap-table2-filter'
import { withNamespaces } from 'react-i18next'
import { translate, getLang } from '../../../utils/translate'

export const View = props => {
		const isMobile = window.innerWidth <= 780
		const { history, t } = props

		const translatedApArr = apartments.map( ap => ({
			...ap,
			type: translate(ap.type),
			position: translate(ap.position),
			status: translate(ap.status)
		}))

		const columns = [{
			dataField: 'id',
			text: 'ID',
			hidden: true
		}, {
			dataField: 'entrance',
			text: `${t('general.entrance')}`,
			headerAlign: 'center',
			align: 'center',
			filter: selectFilter({
				placeholder: `${t('apartments.chooseEntrance')}`,
				options: {
					'A-B': 'A-B',
					'C': 'C',
					'D': 'D',
					'E': 'E'
				}
			})
		}, {
			dataField: 'floor',
			text: `${t('general.floor')}`,
			headerAlign: 'center',
			align: 'center',
			filter: selectFilter({
				placeholder: `${t('apartments.chooseFloor')}`,
				options: {
					1: 1,
					2: 2,
					3: 3,
					4: 4
				}
			})
		}, {
			dataField: 'number',
			text: `${t('general.number')}`,
			headerAlign: 'center',
			align: 'center',
			hidden: isMobile,
			filter: textFilter({
				placeholder: `${t('apartments.inputNumber')}`
			})
		}, {
			dataField: 'type',
			text: `${t('general.type')}`,
			headerAlign: 'center',
			align: 'center',
			formatter: (cell, row) => getRoomAndType(row.rooms, cell, getLang()),
			filter: selectFilter({
				placeholder: `${t('apartments.chooseType')}`,
				options: getTypeFilterOptions(getLang())
			}),
			filterValue: (cell, row) => getRoomAndType(row.rooms, cell, getLang()),
		}, {
			dataField: 'netArea',
			text: `${t('general.netArea')}`,
			headerAlign: 'center',
			align: 'center',
			hidden: isMobile,
			filter: textFilter({
				placeholder: `${t('apartments.inputNetArea')}`
			})
		}, {
			dataField: 'grossArea',
			text: isMobile ? `${t('general.area')}` : `${t('general.grossArea')}`,
			headerAlign: 'center',
			align: 'center',
			filter: textFilter({
				placeholder: `${t('apartments.inputGrossArea')}`
			})
		},
		// {
		// 	dataField: 'position',
		// 	text: `${t('apartments.position')}`,
		// 	headerAlign: 'center',
		// 	align: 'center',
		// 	filter: textFilter({
		// 		placeholder: `${t('apartments.inputPosition')}`
		// 	}),
		// 	hidden: isMobile
		// },
		{
			dataField: 'status',
			text: `${t('general.status')}`,
			headerAlign: 'center',
			align: 'center',
			filter: selectFilter({
				placeholder: `${t('apartments.chooseStatus')}`,
				options: getStatusFilterOptions(getLang())
			}),
			formatter: (cell, row) => {
				const status = getStatusColor(cell)
				return <div className={`u-text--${status.color} u-weight--bold`}>{status.label}</div>
			}
		}]

		const rowEvents = {
			onClick: (e, row) => {
				history.push(`/apartments/${row.entranceUrl}/${row.floor}/${row.number}`)
			}
		}

		return <PageLayout>
			<div className='c-content'>
				<Table
					data={translatedApArr}
					columns={columns}
					classes='fixed'
					headerClasses='c-table__header fixed u-box-shadow u-text--manatee u-weight--normal u-padding-horizontal@desktop u-padding-horizontal-small'
					rowClasses='c-table__row u-box-shadow u-padding-horizontal@desktop u-padding-horizontal-small'
					rowEvents={rowEvents}
					showFilterBtn
				/>
			</div>
		</PageLayout>
}

export default withNamespaces()(View)



// WEBPACK FOOTER //
// ./src/routes/Apartments/components/View.js